import React, { useEffect } from "react";
import { configure } from "mobx";
import axios, { AxiosResponse, AxiosError } from "axios";
import { observer } from "mobx-react-lite";
import { getRefreshToken } from "./helpers/cookies";
import { BrowserRouter, Switch } from "react-router-dom";
import { AuthorizationRoute } from "./AuthorizationRoute";
import { ContainerStyled } from "./App.styles";
import { DefaultRoutes } from "./routes";
import { Route } from "react-router";
import { LoginPage } from "./pages/LoginPage";
import { Layout } from "./modules/Layout";
import { useMst } from "./mobx";
import { useNotifier } from "./helpers/hooks/useNotifier";

setTimeout(() => {
	configure({
		enforceActions: "never",
		reactionScheduler: (f) => {
			setTimeout(f, 1);
		},
	});
}, 1);

axios.interceptors.response.use(
	(response: AxiosResponse) => response,
	(error: AxiosError) => {
		return Promise.reject(error.response);
	}
);

const App = observer(function () {
	const { authStore } = useMst();
	const { isLogged, refreshToken } = authStore;
	useNotifier();

	useEffect(() => {
		if (!isLogged) {
			const token = getRefreshToken();
			if (token) {
				refreshToken(token);
			}
		}
	}, [refreshToken, isLogged]);

	return (
		<ContainerStyled disableGutters maxWidth={false}>
			<BrowserRouter>
				<Switch>
					<Route path={`/${DefaultRoutes.login}`} component={LoginPage} />
					<AuthorizationRoute component={Layout} />
				</Switch>
			</BrowserRouter>
		</ContainerStyled>
	);
});

export default App;
